var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroupUsers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9748 16.4626C15.9206 16.4626 18.3081 14.0746 18.3081 11.1292C18.3081 8.18381 15.9206 5.7959 12.9748 5.7959C10.029 5.7959 7.64148 8.18381 7.64148 11.1292C7.64148 14.0746 10.029 16.4626 12.9748 16.4626ZM15.0873 18.4626H10.8623C6.87356 18.4626 3.64148 21.6959 3.64148 25.6834C3.64148 26.4834 4.28815 27.1292 5.08565 27.1292H20.8623C21.6623 27.1292 22.3081 26.4834 22.3081 25.6834C22.3081 21.6959 19.0748 18.4626 15.0873 18.4626ZM23.604 19.1292H20.5269C22.4415 20.7001 23.6415 23.0501 23.6415 25.6834C23.6415 26.2167 23.4831 26.7084 23.2248 27.1292H28.9748C29.7123 27.1292 30.3081 26.5292 30.3081 25.7584C30.3081 22.1126 27.3248 19.1292 23.604 19.1292ZM21.6415 16.4626C24.2206 16.4626 26.3081 14.3751 26.3081 11.7959C26.3081 9.21673 24.2206 7.12923 21.6415 7.12923C20.5952 7.12923 19.6398 7.48569 18.8615 8.06715C19.3415 8.98881 19.6415 10.0209 19.6415 11.1292C19.6415 12.6092 19.1444 13.9684 18.3252 15.0755C19.1706 15.9292 20.3415 16.4626 21.6415 16.4626Z",
    fill: "#646471"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupUsers);
export default __webpack_public_path__ + "static/media/group-users.d9d21478.svg";
export { ForwardRef as ReactComponent };